import { mixins, styled } from '@bob/library'
import { Markdown } from '@websrc/App/Components/Markdown/Markdown'

export const StepWrapper = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.color.primary};

  ${mixins.padding(50, 0)} :last-child {
    border: none;
  }

  ${mixins.media.min.tablet} {
    ${mixins.padding(30, 0)} :first-child {
      ${mixins.padding(0, 0, 30, 0)};
    }
  }

  & ul > li {
    list-style-type: circle;
  }

  & ol > li {
    list-style: decimal;
  }

  & pre {
    background-color: #f0f0f0;
    ${mixins.padding(10)}
  }
`

export const Title = styled.h2`
  ${mixins.typography.headlineSmall}
  ${mixins.margin.bottom(20)}
`

export const Subtitle = styled.h3`
  ${mixins.typography.subtitleMedium}
`

export const AssetWrapper = styled.div`
  @media print {
    max-width: 50%;
  }
`

export const PrintWrapper = styled.div`
  display: none;
  @media print {
    display: flex;
    flex-wrap: wrap;
    margin: -10px;
  }
`

export const PrintItem = styled.div`
  border: 1px dashed black;
  border-radius: 30px;
  margin: 20px 10px 0 10px;
  flex: 1 1 44%;
  display: flex;
  max-width: 48%;
  position: relative;

  label {
    position: absolute;
    top: -1em;
    left: 15px;
    background: white;
    border: 1px solid black;
    padding: 0 10px;
    line-height: 2em;
    border-radius: 30px;
    font-size: 0.8rem;
  }
`

export const PrintItemAsset = styled.div`
  display: flex;
  align-items: flex-start;
  width: 100%;
  padding: 20px;
  max-height: none;

  img {
    position: relative;
    max-width: 100%;
    width: 100%;
  }
`

export const CarouselWrapper = styled.div`
  @media print {
    display: none;
  }
`

export const GalleryItem = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`

export const GalleryItemAsset = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 0;
  width: 100%;

  @media print {
    width: 49%;
    display: inline-block;
  }

  max-height: 80vh; // Fallback
  max-height: calc(90vh - 150px);

  img {
    position: relative;
    max-width: 80%;
    max-height: 100%;
    height: 100%;
    width: 100%;
  }

  @media print {
    max-height: none;
  }
`

export const CodeStackWrapper = styled.div`
  width: 100%;
  max-width: 600px;
`

export const GalleryPaginationAsset = styled.div`
  width: 85px;
  height: 55px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 0;
  margin: 15px;

  & > img {
    width: auto;
    max-height: 100%;
    max-width: 100%;
    position: relative;
  }
`

export const Hints = styled.div`
  background-color: #f0f0f0;
  padding: 10px;
`

export const FileContainer = styled.div`
  ${mixins.margin(40, 0)}
`

export const FileDescription = styled.span`
  ${mixins.margin.left(10)}
  ${mixins.typography.paragraphMedium}
`

export const WarningWrapper = styled.div`
  & > svg {
    ${mixins.margin.top(5)}
  }
`

export const WarningHeader = styled.div`
  display: flex;
  align-items: center;
`

export const WarningTitle = styled.h3`
  ${mixins.typography.headlineXs}
  ${mixins.margin(0)}
  ${mixins.margin.left(10)}
  color: ${mixins.colors.corporateRed};
`

export const WarningMarkdown = styled(Markdown)`
  ${mixins.margin(15, 0)}
  ${mixins.margin.left(30)}
  /* body text */
  & p,
  & li {
    color: ${mixins.colors.corporateRed};
  }
`

export const ButtonPrimary = styled.a`
  ${mixins.cta.primary('blue')}
`
